import supplier from './supplier'

export default {
  namespaced: true,
  modules: {
    supplier
  }
}
